import React, { Component } from "react";
import TimeSliders from "../../components/schedule/TimeSliders";
import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import { isNormalInteger } from "../../util/IsNormalInteger";

class TimeSlidersContainer extends Component {
  state = {
    matchDurationOpen: false,
    // timeBetweenMatchesOpen: false,
    matchDuration:
      this.props.tournament.matchDuration !== undefined
        ? this.props.tournament.matchDuration
        : defaultMatchTimes.matchDuration,
    timeBetweenMatches:
      this.props.tournament.timeBetweenMatches !== undefined
        ? this.props.tournament.timeBetweenMatches
        : defaultMatchTimes.timeBetweenMatches,
    customMatchDuration:
      this.props.tournament.customMatchDuration !== undefined
        ? this.props.tournament.customMatchDuration
        : {},
    calculating: false,
  };

  // handleTimeBetweenMatchesOpen = () => {
  //   this.setState({
  //     timeBetweenMatchesOpen: !this.state.timeBetweenMatchesOpen
  //   });
  // };

  handleMatchDurationOpen = () => {
    this.setState({
      matchDurationOpen: !this.state.matchDurationOpen,
      calculating: false,
    });
  };

  handleChange = (e) => {
    e.preventDefault();
    let toUpdate = {};
    let newValue = parseInt(e.target.value, 10).toString();
    if (isNormalInteger(newValue)) {
      toUpdate[e.target.name] = newValue;
    }
    if (
      (e.target.value === "" && e.target.name === "matchDuration") ||
      (e.target.value === "0" && e.target.name === "matchDuration")
    ) {
      toUpdate[e.target.name] = "0";
    }
    if (e.target.value === "" && e.target.name === "timeBetweenMatches") {
      toUpdate[e.target.name] = "0";
    }
    this.setState(toUpdate);
  };

  handleCustomMatchDurationChange = (e, id) => {
    e.preventDefault();
    let customMatchDuration = this.state.customMatchDuration;
    let newValue = parseInt(e.target.value, 10).toString();
    if (isNormalInteger(newValue)) {
      customMatchDuration[id] = newValue;
    } else {
      customMatchDuration[id] = "";
    }
    if (e.target.value === "") {
      customMatchDuration[id] = "";
    }
    this.setState({ customMatchDuration: customMatchDuration });
  };

  handleSubmitMatchDuration = (e) => {
    e.preventDefault();
    const db = window.firebase.firestore();
    let batch = db.batch();
    this.setState({ calculating: true });
    batch.update(
      db.collection("tournaments").doc(this.props.tournament[".key"]),
      {
        matchDuration: parseInt(this.state.matchDuration, 10).toString(),
        customMatchDuration: this.state.customMatchDuration,
        timeBetweenMatches: parseInt(
          this.state.timeBetweenMatches,
          10
        ).toString(),
      }
    );

    Object.keys(this.props.tournament.fields || {}).forEach((fieldKey) => {
      batch.set(db.collection("cacheUpdatesForField").doc(), {
        tournamentId: this.props.tournament[".key"],
        fieldId: fieldKey,
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
      // Object.keys(this.props.daysByKey).forEach((dayKey) => {
      //   batch.set(db.collection("cacheUpdates").doc(), {
      //     tournamentId: this.props.tournament[".key"],
      //     fieldId: fieldKey,
      //     dayId: dayKey,
      //     status: "pending",
      //     timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      //   });
      // });
    });

    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }

    batch.commit().then(() => {
      this.handleMatchDurationOpen();
    });
  };

  // handleSubmitTimeBetweenMatches = e => {
  //   e.preventDefault();
  //   window.firebase
  //     .firestore()
  //     .collection("tournaments")
  //     .doc(this.props.tournament[".key"])
  //     .update({
  //       timeBetweenMatches: parseInt(
  //         this.state.timeBetweenMatches,
  //         10
  //       ).toString()
  //     });
  //   this.handleTimeBetweenMatchesOpen();
  // };

  handleLock = () => {
    let lock = this.props.tournament.scheduleLocked || false;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({
        scheduleLocked: !lock,
      });
  };

  render() {
    let elements = [],
      i = 0,
      j = 0;

    let poules = this.props.poules.sort((a, b) => {
      if (a.indexNum > b.indexNum) {
        return 1;
      } else if (a.indexNum < b.indexNum) {
        return -1;
      } else {
        return a.num - b.num;
      }
    });
    let brackets = this.props.brackets.sort((a, b) => {
      if (a.indexNum > b.indexNum) {
        return 1;
      } else if (a.indexNum < b.indexNum) {
        return -1;
      } else {
        return a.num - b.num;
      }
    });

    while (i < poules.length && j < brackets.length) {
      if (poules[i].num <= brackets[j].num) {
        const poule = poules[i];
        // const pouleElement = this.getPouleElement(poule);
        elements.push(poule);
        i++;
      } else {
        const bracket = brackets[j];
        // const bracketElement = this.getBracketElement(bracket);
        elements.push(bracket);
        j++;
      }
    }
    const structureElements = elements
      .concat(poules.slice(i).map((poule) => poule))
      .concat(brackets.slice(j).map((bracket) => bracket));
    return (
      <TimeSliders
        {...this.state}
        tournament={this.props.tournament}
        handleChange={this.handleChange}
        handleMatchDurationOpen={this.handleMatchDurationOpen}
        handleTimeBetweenMatchesOpen={this.handleTimeBetweenMatchesOpen}
        handleSubmitMatchDuration={this.handleSubmitMatchDuration}
        handleSubmitTimeBetweenMatches={this.handleSubmitTimeBetweenMatches}
        structureElements={structureElements}
        divisions={this.props.divisions}
        handleCustomMatchDurationChange={this.handleCustomMatchDurationChange}
        handleLock={this.handleLock}
        calculating={this.state.calculating}
      />
    );
  }
}

export default TimeSlidersContainer;
